<template>
	<div id="st-home">
		<el-row :gutter="20">
			<el-col :span="4">
		    	<SecondMenu type="1" />
			</el-col>
			<el-col :span="20">
				<el-form ref="formRef" :model="form" :rules="rules" label-width="120px" label-position="top">
		    		<el-form-item :label="$t('avatar')">
				      	<TuUpload show-type="avatar" :image-url="avatar_url.url" u-action="avatar" ref="avatar" @start="onUploadStart" @success="onUploadSuccess" />
				    </el-form-item>

				    <el-row :gutter="24">
				    	<el-col :span="12">
				    		<el-form-item label="First Name" prop="first_name">
						      	<el-input v-model="form.first_name" show-word-limit></el-input>
						    </el-form-item>
				    	</el-col>
				    	<el-col :span="12">
				    		<el-form-item label="Last Name" prop="last_name">
						      	<el-input v-model="form.last_name" show-word-limit></el-input>
						    </el-form-item>
				    	</el-col>
				    </el-row>

				    <el-row :gutter="24">
				    	<el-col :span="12">
				    		<el-form-item :label="$t('age')" prop="age">
						      	<el-input v-model="form.age"></el-input>
						    </el-form-item>
				    	</el-col>
				    	<el-col :span="12">
				    		<el-form-item :label="$t('gender')">
						      	<el-radio-group v-model="form.gender">
									<el-radio :label="1">{{ $t('male') }}</el-radio>
									<el-radio :label="2">{{ $t('female') }}</el-radio>
								</el-radio-group>
						    </el-form-item>
				    	</el-col>
				    </el-row>

				    <el-row :gutter="24">
				    	<el-col :span="12">
				    		<!-- What's your goal? -->
						    <el-form-item label="What's your goal?">
								<el-select v-model="form.goal" style="width: 100%;">
							      <el-option
							        v-for="item in started.goal"
							        :key="item.value"
							        :label="item.label"
							        :value="item.value"
							      />
							    </el-select>
						    </el-form-item>
				    	</el-col>
				    	<el-col :span="12">
				    		<!-- What's your Chinese level? -->
						    <el-form-item label="What's your Chinese level?">
								<el-select v-model="form.level" style="width: 100%;">
							      <el-option
							        v-for="item in started.level"
							        :key="item.value"
							        :label="item.label"
							        :value="item.value"
							      />
							    </el-select>
						    </el-form-item>
				    	</el-col>
				    </el-row>
				    
				    <!-- Any specific interests? -->
				    <el-form-item label="Any specific interests?">
						<el-select v-model="form.interests" multiple style="width: 100%;">
					      <el-option
					        v-for="item in started.interests"
					        :key="item.value"
					        :label="item.label"
					        :value="item.value"
					      />
					    </el-select>
				    </el-form-item>
				    <!-- <el-form-item :label="$t('what-subject')" prop="subject_id">
				    	<el-select v-model="form.subject_id" size="medium" clearable filterable placeholder="Select Subject" style="width: 100%;">
							<block v-for="item, index in subjectData.subject">
								<el-option v-for="it, i in item.children" :label="item.name + '(' + it.name + ')'" :value="it.id"></el-option>
							</block>
						</el-select>
				    </el-form-item>
				    <el-form-item :label="$t('solved-problem')">
				      	<el-input v-model="form.content" type="textarea" rows="3" show-word-limit></el-input>
				    </el-form-item> -->
				    <el-form-item>
				      <el-button type="primary" @click="onSubmit">{{ $t('Save') }}</el-button>
				    </el-form-item>
				</el-form>
			</el-col>
		</el-row>
	</div>
</template>
<script>
import { mapActions, mapGetters } from 'vuex'
import SecondMenu from '@/components/SecondMenu'
import StudentApi from '@/api/student'
import TimeControl from '@/utils/time-control'
import TuUpload from '@/components/TuUpload'
import Config from '@/utils/config'

export default {
	name: "st-home",
	components: {
		SecondMenu,
		TuUpload
	},
	data() {
		return {
			rows: [],
			avatar_url: {},
			form: {
				profile_id: '',
				first_name: '',
				last_name: '',
				class_name: '-',
				subject_id: '',
				birthday: '2000',
				use_rate: 0,
				school_nature: 0,
				content: '',
				is_main: 0,
				relationship: 0 // 0 未知 1 兄弟 2 姐妹
			},
			birthdayColumns: [],
			rules: {
				first_name: [
					{
					    required: true,
					    message: this.$t('auth.enter-your-name'),
					    trigger: 'blur'
					}
				],
				last_name: [
					{
					    required: true,
					    message: this.$t('enter-your-last-name'),
					    trigger: 'blur'
					}
				],
			},
		}
	},
	computed: {
		...mapGetters([
			'subjectData', 'userInfo'
		]),
		started() {
			return Config.studentConfigInfo();
		}
	},
	created() {
		this.getApiInfoData();
	},
	methods: {
		getApiInfoData() {
			StudentApi.profile().then(res => {
				this.rows = res.data;
				this.onAddProfile(0);
			});
		},
		onAddProfile(value) {
			let form = value == -1 ? {} : this.rows[value];
			this.form = {
				profile_id: form.profile_id || '',
				is_main: form.is_main || 0,
				first_name: form.first_name || '',
				last_name: form.last_name || '',
				class_name: form.class_name || '',
				subject_id: form.subject_id || '',
				birthday: form.birthday || '',
				use_rate: form.use_rate || 0,
				school_nature: form.school_nature || 0,
				content: form.content || '',
				relationship: parseInt(form.relationship || 0),
				age: form.age,
				gender: form.gender,
				level: form.level.toString(),
				goal: form.goal.toString(),
				interests: form.interests ? JSON.parse(form.interests) : [],
			}
			this.avatar_url = { code: '', url: form.avatar_url || '' }
		},
		handleDateShow(value) {
			return TimeControl.getFormatTime(value, 'L')
		},
		handleSubjectName(subject_id) {
			for(let i in this.subjectData.subject) {
				let level = this.subjectData.subject[i].children[subject_id] || '';
				if(!!level) {
					return this.subjectData.subject[i].name + ' (' + level.name + ')';
				}
			}
		},
		onUploadStart(value) {

		},
		onUploadSuccess(value) {
			this.avatar_url = {code: value.code, url: value.path};
		},
		onSubmit() {
			let that = this
			this.$refs.formRef.validate((valid) => {
				if(valid) {
					// if(!this.avatar_url || !this.avatar_url.url) {
					// 	this.$message.error("Avatar needs to be uploaded");
					// 	return false;
					// }
					// if(this.isSubAccount && this.form.relationship == 0) {
					// 	this.$message.error('You need to fill in the relationship with the main account')
					// 	return false;
					// }
					let form = this.form;
					form.profile_avatar_url = this.avatar_url.code;
					form.profile_first_name = form.first_name;
					form.profile_last_name = form.last_name;

					StudentApi.store(this.form).then(res => {
						this.$message.success(this.$t('Save Success'));
						this.drawer = false;
						this.$store.dispatch('GetUserInfo');
						if (!!this.redirect && (this.redirect == '/order' || this.redirect == 'order')) {
							this.$router.push("/order")
						} else {
							this.getApiInfoData();
						}
					});
				}
			})
		}
	}
}
</script>
<style lang="less">
#st-home {
	.time {
	  font-size: 13px;
	  color: #999;
		display: inline-block;
		white-space: nowrap;
		// width: 80%;
		overflow: hidden;
		text-overflow: ellipsis;
		text-align: right;
	}

	.title {
		font-size: 13px;
		font-weight: 600;

		.desc {
			word-break: break-all;
			line-height: 1.4;
			margin-top: 5px;
			color: #666;
			display: -webkit-box;
			font-weight: 500;
			-webkit-line-clamp: 2;
			overflow: hidden;
			-webkit-box-orient: vertical;
		}
	}

	.bottom {
	  margin-top: 8px;
	  line-height: 16px;
	  display: flex;
	  justify-content: space-between;
	  align-items: center;
	}

	.button {
	  padding: 0;
	  min-height: auto;
	}

	.image {
	  width: 100%;
	  height: 250px;
	  display: block;
	}
}
</style>